export interface ComicChapter {
  id: number;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: number;
  slug: string;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  longDescription: string;
  category: string;
  tags: string[];
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  followers: number;
  chapterCount: number;
  updatedAt: string;
  chapters: ComicChapter[];
}

export const categories: { slug: string; name: string; icon: string; count: number; description: string }[] = [
  { slug: 'rexue', name: '热血', icon: 'ri-fire-line', count: 128, description: '热血战斗类韩漫，充满激情与力量的碰撞，每一页都让人热血沸腾。' },
  { slug: 'lianai', name: '恋爱', icon: 'ri-heart-line', count: 256, description: '甜蜜浪漫的恋爱韩漫，讲述心动瞬间与美好爱情故事。' },
  { slug: 'xiaoyuan', name: '校园', icon: 'ri-building-line', count: 89, description: '青春校园题材韩漫，记录校园生活中的欢笑与泪水。' },
  { slug: 'qihuan', name: '奇幻', icon: 'ri-magic-line', count: 145, description: '奇幻冒险类韩漫，带你进入充满魔法与异世界的神奇旅程。' },
  { slug: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line', count: 67, description: '悬疑推理类韩漫，层层谜团引人入胜，烧脑又刺激。' },
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line', count: 112, description: '轻松搞笑的韩漫作品，欢乐不断笑点满满。' },
  { slug: 'dongzuo', name: '动作', icon: 'ri-sword-line', count: 94, description: '动作打斗类韩漫，精彩的格斗场面让你目不暇接。' },
  { slug: 'richang', name: '日常', icon: 'ri-sun-line', count: 78, description: '温馨日常类韩漫，描绘平凡生活中的美好与感动。' },
];

export const comics: Comic[] = [
  {
    id: 1,
    slug: 'dushi-jiangshen',
    title: '都市降神',
    author: '金贤秀',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20urban%20fantasy%20theme%2C%20male%20protagonist%20with%20dark%20hair%20and%20sharp%20eyes%2C%20modern%20city%20background%2C%20dramatic%20lighting%2C%20clean%20illustration%20with%20bold%20lines%2C%20professional%20webtoon%20cover%20design%2C%20warm%20and%20cool%20tone%20contrast&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '一个普通上班族意外获得神灵之力，在都市中展开惊险刺激的降妖除魔之旅。',
    longDescription: '普通上班族李明宇在一次意外中获得了古老神灵的力量。从此他的生活彻底改变——白天是平凡的职场人，夜晚则化身为都市守护者。面对接踵而至的超自然事件，他必须学会驾驭这股强大力量，同时保护身边的人不被卷入危险。一场关于力量、责任与人性的都市奇幻故事就此展开。',
    category: 'rexue',
    tags: ['奇幻', '都市', '热血', '战斗'],
    status: '连载中',
    rating: 4.8,
    views: 1250000,
    followers: 89600,
    chapterCount: 186,
    updatedAt: '2026-08-05',
    chapters: Array.from({ length: 20 }, (_, i) => ({
      id: i + 1,
      title: `第${186 - i}话 - ${['觉醒之日', '暗流涌动', '初战告捷', '意外相遇', '深渊之门', '守护之誓', '真相浮现', '决战前夕', '未曾设想的道路', '新的开始', '风暴来临', '并肩作战', '黑暗中的光', '命运的抉择', '力量的代价', '信任的考验', '破晓之前', '最后的防线', '传承', '未来'][i] || '新篇章'}`,
      number: 186 - i,
      updatedAt: `2026-0${8 - Math.floor(i / 10)}-${String(30 - i * 2).padStart(2, '0')}`,
    })),
  },
  {
    id: 2,
    slug: 'milian-xinghe',
    title: '蜜恋星河',
    author: '李智恩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%2C%20beautiful%20female%20protagonist%20with%20long%20flowing%20hair%2C%20starry%20night%20sky%20background%2C%20soft%20pink%20and%20purple%20tones%2C%20romantic%20atmosphere%2C%20clean%20webtoon%20illustration%20style%2C%20elegant%20composition&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '在星河之下，两个截然不同的灵魂相遇相知，上演最甜蜜的浪漫恋曲。',
    longDescription: '天文学家金秀雅在星空观测站邂逅了自由奔放的音乐人崔在赫。她严谨理性，他浪漫随性；她相信科学，他追随灵感。两个截然不同的灵魂，因为一场流星雨而产生了交集。在璀璨星河之下，他们将展开一段关于梦想、理解与成长的美好恋情。',
    category: 'lianai',
    tags: ['恋爱', '浪漫', '都市', '甜宠'],
    status: '连载中',
    rating: 4.9,
    views: 2310000,
    followers: 152300,
    chapterCount: 142,
    updatedAt: '2026-08-04',
    chapters: Array.from({ length: 20 }, (_, i) => ({
      id: i + 1,
      title: `第${142 - i}话`,
      number: 142 - i,
      updatedAt: `2026-0${8 - Math.floor(i / 8)}-${String(25 - i).padStart(2, '0')}`,
    })),
  },
  {
    id: 3,
    slug: 'xueyuan-biji',
    title: '血源笔记',
    author: '朴志浩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20horror%20mystery%20manhwa%20cover%2C%20dark%20atmosphere%2C%20student%20holding%20a%20mysterious%20bloodstained%20notebook%2C%20dim%20classroom%20background%2C%20red%20and%20black%20color%20scheme%2C%20creepy%20webtoon%20cover%20design%2C%20professional%20illustration&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '一本神秘的血色笔记，揭开了校园深处隐藏多年的恐怖秘密。',
    longDescription: '转学生韩智敏在图书馆偶然发现了一本布满暗红色字迹的旧笔记本。从那以后，她身边接连发生诡异事件，而笔记本中记载的内容似乎与十年前的校园失踪案有着千丝万缕的联系。为了揭开真相，她必须直面隐藏在校园平静表面之下的黑暗深渊。',
    category: 'xuanyi',
    tags: ['悬疑', '惊悚', '校园', '推理'],
    status: '已完结',
    rating: 4.7,
    views: 1890000,
    followers: 98700,
    chapterCount: 98,
    updatedAt: '2026-07-28',
    chapters: Array.from({ length: 20 }, (_, i) => ({
      id: i + 1,
      title: `第${98 - i}话`,
      number: 98 - i,
      updatedAt: `2026-07-${String(28 - i).padStart(2, '0')}`,
    })),
  },
  {
    id: 4,
    slug: 'jianyu-kuangxiang',
    title: '剑与狂想',
    author: '尹智勋',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20action%20manhwa%20cover%2C%20warrior%20with%20sword%20in%20medieval%20fantasy%20setting%2C%20epic%20battle%20scene%2C%20golden%20and%20crimson%20accents%2C%20dramatic%20composition%2C%20detailed%20armor%20design%2C%20webtoon%20cover%20style&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '剑术天才穿越异世界，用手中之剑开创属于自己的传奇篇章。',
    longDescription: '全国剑术冠军崔镇宇在一场比赛中意外穿越到了充满魔法与怪物的异世界。在这里，他的剑术天赋被赋予了全新的意义。与精灵弓箭手、矮人铁匠和魔法师少女结成冒险小队，他踏上了讨伐魔王、拯救世界的史诗旅程。而这趟旅程的终点，将揭示他穿越背后的惊天秘密。',
    category: 'qihuan',
    tags: ['奇幻', '冒险', '穿越', '战斗'],
    status: '连载中',
    rating: 4.6,
    views: 1560000,
    followers: 112400,
    chapterCount: 210,
    updatedAt: '2026-08-05',
    chapters: Array.from({ length: 20 }, (_, i) => ({
      id: i + 1,
      title: `第${210 - i}话`,
      number: 210 - i,
      updatedAt: `2026-0${8 - Math.floor(i / 10)}-${String(30 - i * 2).padStart(2, '0')}`,
    })),
  },
  {
    id: 5,
    slug: 'qingchun-zouxiangqu',
    title: '青春奏响曲',
    author: '郑秀晶',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20school%20life%20manhwa%20cover%2C%20group%20of%20high%20school%20students%20in%20uniform%2C%20music%20room%20setting%20with%20instruments%2C%20bright%20and%20warm%20color%20palette%2C%20youthful%20and%20energetic%20vibe%2C%20clean%20anime%20style%20illustration&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '五个热爱音乐的高中生组建乐队，用青春谱写最动人的乐章。',
    longDescription: '热爱钢琴的高中生姜美娜一直独自练习，直到她在学校的音乐节上遇到了吉他手、鼓手、贝斯手和主唱。五个性格迥异却同样热爱音乐的年轻人决定组建校园乐队。在追求音乐梦想的道路上，他们经历了友情的考验、家庭的反对、比赛的挫折，但音乐始终是他们心灵的纽带。',
    category: 'xiaoyuan',
    tags: ['校园', '音乐', '青春', '友情'],
    status: '已完结',
    rating: 4.8,
    views: 920000,
    followers: 78500,
    chapterCount: 76,
    updatedAt: '2026-06-15',
    chapters: Array.from({ length: 16 }, (_, i) => ({
      id: i + 1,
      title: `第${76 - i}话`,
      number: 76 - i,
      updatedAt: `2026-06-${String(15 - i).padStart(2, '0')}`,
    })),
  },
  {
    id: 6,
    slug: 'gaoxiao-tiandao',
    title: '搞笑天道',
    author: '崔顺哲',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20comedy%20manhwa%20cover%2C%20funny%20male%20protagonist%20with%20exaggerated%20expression%2C%20colorful%20cartoonish%20style%2C%20bright%20yellow%20and%20orange%20background%2C%20humorous%20webtoon%20cover%20design%2C%20playful%20composition&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '一个倒霉蛋被选中成为搞笑之神的人间代理人，闹出无尽笑话。',
    longDescription: '生活不如意的平凡青年朴大勇莫名其妙地被选为了"搞笑天道"的接班人。为了完成任务——让世界上不开心的人笑起来，他必须学会各种匪夷所思的搞笑技能。从尴尬的冷笑话到惊天动地的滑稽失误，他的每一次"拯救不开心"都变成了一场失控的搞笑灾难。',
    category: 'gaoxiao',
    tags: ['搞笑', '喜剧', '奇幻', '日常'],
    status: '连载中',
    rating: 4.5,
    views: 1780000,
    followers: 135600,
    chapterCount: 165,
    updatedAt: '2026-08-04',
    chapters: Array.from({ length: 20 }, (_, i) => ({
      id: i + 1,
      title: `第${165 - i}话`,
      number: 165 - i,
      updatedAt: `2026-0${8 - Math.floor(i / 8)}-${String(24 - i).padStart(2, '0')}`,
    })),
  },
  {
    id: 7,
    slug: 'wuxian-jingjie',
    title: '无限境界',
    author: '安在旭',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20action%20martial%20arts%20manhwa%20cover%2C%20powerful%20fighter%20with%20glowing%20fists%2C%20dynamic%20battle%20pose%2C%20urban%20setting%20with%20energy%20effects%2C%20intense%20red%20and%20black%20color%20scheme%2C%20professional%20webtoon%20illustration&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '武道天才突破人类极限，开启一个全新的武学境界时代。',
    longDescription: '在一场地下格斗赛中，默默无闻的武道修炼者宋泰浩突然觉醒了"无限境界"——一种超越常人理解的武学潜力。消息传出后，世界各地的武术宗门、秘密组织纷纷向他伸出橄榄枝或刀锋。在各方势力的漩涡中心，宋泰浩必须不断突破自我，走向武学巅峰。',
    category: 'dongzuo',
    tags: ['动作', '格斗', '热血', '都市'],
    status: '连载中',
    rating: 4.7,
    views: 2010000,
    followers: 143200,
    chapterCount: 198,
    updatedAt: '2026-08-05',
    chapters: Array.from({ length: 20 }, (_, i) => ({
      id: i + 1,
      title: `第${198 - i}话`,
      number: 198 - i,
      updatedAt: `2026-0${8 - Math.floor(i / 10)}-${String(28 - i * 2).padStart(2, '0')}`,
    })),
  },
  {
    id: 8,
    slug: 'richang-yu-guang',
    title: '日常余光',
    author: '韩智慧',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20slice%20of%20life%20manhwa%20cover%2C%20young%20woman%20sitting%20by%20window%20with%20coffee%2C%20cozy%20apartment%20setting%2C%20warm%20afternoon%20light%2C%20soft%20pastel%20color%20palette%2C%20gentle%20and%20calm%20webtoon%20illustration%20style&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '独居女生的温暖日常，在平凡中发现生活的美好与诗意。',
    longDescription: '二十五岁的林素敏独自在首尔生活，做着普通的出版社编辑工作。她喜欢在下班后逛菜市场，周末在咖啡馆看书，偶尔与邻居家的猫互动。这是一部关于孤独却温暖、平凡却美好的都市日常漫画。通过素敏的视角，我们重新发现那些被忽略的生活中的小确幸。',
    category: 'richang',
    tags: ['日常', '治愈', '都市', '温馨'],
    status: '连载中',
    rating: 4.9,
    views: 780000,
    followers: 95600,
    chapterCount: 89,
    updatedAt: '2026-08-03',
    chapters: Array.from({ length: 20 }, (_, i) => ({
      id: i + 1,
      title: `第${89 - i}话`,
      number: 89 - i,
      updatedAt: `2026-0${8 - Math.floor(i / 8)}-${String(22 - i).padStart(2, '0')}`,
    })),
  },
  {
    id: 9,
    slug: 'mofa-xiaoyuan-lu',
    title: '魔法校园录',
    author: '金敏秀',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20magic%20academy%20manhwa%20cover%2C%20students%20casting%20spells%20in%20magical%20school%20uniform%2C%20floating%20crystals%20and%20magic%20circles%2C%20mystical%20blue%20and%20purple%20atmosphere%2C%20fantasy%20school%20setting%2C%20detailed%20webtoon%20illustration&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    description: '魔法学院的新生入学，展开一段充满惊喜与挑战的魔法学习之旅。',
    longDescription: '十四岁的朴小星收到了来自"云端魔法学院"的录取通知书，从此踏上魔法学习之路。在这所隐藏在云层之上的古老学院中，她结识了来自各地的魔法学徒，学习各种神奇法术，同时也发现学院深处隐藏着不为人知的秘密。一场关于友谊、成长与魔法的大冒险正式启程。',
    category: 'qihuan',
    tags: ['奇幻', '魔法', '校园', '冒险'],
    status: '连载中',
    rating: 4.6,
    views: 1340000,
    followers: 102800,
    chapterCount: 156,
    updatedAt: '2026-08-04',
    chapters: Array.from({ length: 20 }, (_, i) => ({
      id: i + 1,
      title: `第${156 - i}话`,
      number: 156 - i,
      updatedAt: `2026-0${8 - Math.floor(i / 8)}-${String(24 - i).padStart(2, '0')}`,
    })),
  },
  {
    id: 10,
    slug: 'hei-an-zhong-sheng',
    title: '黑暗重生',
    author: '李东旭',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20dark%20fantasy%20manhwa%20cover%2C%20antihero%20male%20protagonist%20with%20shadow%20powers%2C%20gothic%20cityscape%20at%20night%2C%20black%20and%20crimson%20accents%2C%20mysterious%20and%20brooding%20atmosphere%2C%20professional%20webtoon%20cover%20design&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '死而复生的复仇者，用黑暗之力向背叛者展开冷酷无情的复仇。',
    longDescription: '权世勋被最信任的伙伴背叛杀害，却在三天后奇迹般复活，并且获得了操控黑暗的能力。他要做的只有一件事——让那些背叛他的人付出代价。但随着复仇的深入，他逐渐发现自己的死亡背后隐藏着一个更大的阴谋，而这个阴谋可能威胁到整个世界的存亡。',
    category: 'dongzuo',
    tags: ['动作', '复仇', '黑暗', '奇幻'],
    status: '连载中',
    rating: 4.8,
    views: 2670000,
    followers: 178900,
    chapterCount: 220,
    updatedAt: '2026-08-05',
    chapters: Array.from({ length: 20 }, (_, i) => ({
      id: i + 1,
      title: `第${220 - i}话`,
      number: 220 - i,
      updatedAt: `2026-0${8 - Math.floor(i / 10)}-${String(30 - i * 2).padStart(2, '0')}`,
    })),
  },
  {
    id: 11,
    slug: 'huakai-shengyin',
    title: '花开的声音',
    author: '朴恩彬',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romance%20drama%20manhwa%20cover%2C%20couple%20standing%20in%20flower%20garden%2C%20spring%20cherry%20blossom%20setting%2C%20soft%20pink%20and%20white%20tones%2C%20emotional%20and%20tender%20atmosphere%2C%20beautiful%20webtoon%20illustration%20style&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '聋哑花艺师与音乐制作人的意外邂逅，演绎超越语言的纯美爱情。',
    longDescription: '聋哑女孩郑花香继承了奶奶的花店，她用手与花朵对话，用心灵感知世界的美好。音乐制作人金贤宇偶然经过花店，被花香和她安静的气质深深吸引。他们的相遇像花开一般静美——不需要语言，一个眼神、一次触碰就能传递最深的情感。这是一个关于爱的力量能穿越一切障碍的温暖故事。',
    category: 'lianai',
    tags: ['恋爱', '治愈', '都市', '文艺'],
    status: '已完结',
    rating: 4.9,
    views: 1120000,
    followers: 87600,
    chapterCount: 64,
    updatedAt: '2026-05-20',
    chapters: Array.from({ length: 14 }, (_, i) => ({
      id: i + 1,
      title: `第${64 - i}话`,
      number: 64 - i,
      updatedAt: `2026-05-${String(20 - i).padStart(2, '0')}`,
    })),
  },
  {
    id: 12,
    slug: 'xueyuan-diwang',
    title: '学院帝王',
    author: '郑世勋',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20school%20action%20manhwa%20cover%2C%20confident%20male%20student%20leader%20standing%20in%20front%20of%20school%20building%2C%20dramatic%20lighting%2C%20strong%20presence%2C%20modern%20school%20uniform%2C%20cool%20webtoon%20cover%20design&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '从底层逆袭成为校园最强，昔日被欺凌的少年谱写热血反击传奇。',
    longDescription: '江东高中曾有一个不成文的规则——弱者被踩在脚下。金泰成就是那个被所有人踩在脚下的人。直到他遇到了一位隐退的格斗大师，开始秘密修炼。三个月后，曾经欺凌他的每一个人都将为自己的行为付出代价。但这并非简单的复仇故事，而是一个少年在力量与正义之间寻找平衡的成长史诗。',
    category: 'xiaoyuan',
    tags: ['校园', '格斗', '热血', '成长'],
    status: '连载中',
    rating: 4.5,
    views: 1430000,
    followers: 167300,
    chapterCount: 178,
    updatedAt: '2026-08-04',
    chapters: Array.from({ length: 20 }, (_, i) => ({
      id: i + 1,
      title: `第${178 - i}话`,
      number: 178 - i,
      updatedAt: `2026-0${8 - Math.floor(i / 8)}-${String(24 - i).padStart(2, '0')}`,
    })),
  },
];